import React, { useState } from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
import { images } from '../data/site';
export function BeforeAfter() {
  const [pos, setPos] = useState(50);
  return <section id="work" className="bg-white py-20 lg:py-28" data-id="element-23" data-mp="3og1dgq24i0ap">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-24" data-mp="3ofhy9h3uxq0d">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end" data-id="element-25" data-mp="3sglcjz69bdzh">
          <h2 className="max-w-2xl font-display text-5xl font-extrabold uppercase leading-[0.95] text-ink lg:text-6xl" data-id="element-26" data-mp="3epg7uio17via">
            Before. After. <span className="text-brand" data-id="element-27" data-mp="3jhgawjzef4j3">No trace.</span>
          </h2>
          <p className="max-w-md text-lg leading-relaxed text-ink-muted" data-id="element-28" data-mp="34sjvg1v0ip8g">
            Drag the slider. This living-room wall had a fist-sized hole and water staining — patched, textured and
            painted in a single visit.
          </p>
        </div>

        <div className="relative mt-12 aspect-[4/3] w-full select-none overflow-hidden rounded-2xl bg-canvas sm:aspect-[16/9]" data-id="element-29" data-mp="2vt6u5wh1l6yt">
          <img src={images.after} alt="Wall after repair, smooth and freshly painted" className="absolute inset-0 h-full w-full object-cover" data-id="element-30" data-mp="x4aexg2ofx2p" />
          <img src={images.before} alt="Wall before repair with a hole and water stains" className="absolute inset-0 h-full w-full object-cover" style={{
          clipPath: `inset(0 ${100 - pos}% 0 0)`
        }} data-id="element-31" data-mp="t2fa41ljf1k6" />

          <span className="absolute left-4 top-4 rounded-md bg-ink px-3 py-1.5 font-display text-lg font-bold uppercase text-white" data-id="element-32" data-mp="edj5keiow6ob">
            Before
          </span>
          <span className="absolute right-4 top-4 rounded-md bg-brand px-3 py-1.5 font-display text-lg font-bold uppercase text-white" data-id="element-33" data-mp="9d4vkqxj2mnn">
            After
          </span>

          <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white" style={{
          left: `${pos}%`
        }} aria-hidden="true" data-id="element-34" data-mp="jbkql4zoeg2f">
            <span className="absolute left-1/2 top-1/2 grid h-12 w-12 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-white text-ink shadow-lg" data-id="element-35" data-mp="3rqm9k3gunjqk">
              <MoveHorizontalIcon className="h-5 w-5" data-id="element-36" data-mp="1qq7vffxqj5we" />
            </span>
          </div>

          <input type="range" min={0} max={100} value={pos} onChange={e => setPos(Number(e.target.value))} aria-label="Compare before and after" className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0" data-id="element-37" data-mp="1voj5nrrxzif5" />
        </div>
      </div>
    </section>;
}